// AUTO-GENERATED by partner-training tour generator — do not edit by hand.
// One narration tour per training step so each "Show me in Experience" starts a
// tour specific to that use case.
export const TRAINING_TOURS: any[] = [
  {
    "id": "training-d1-s6",
    "pluginId": "identity-core",
    "title": "Create Your Lab Identity",
    "summary": "We will create a lab identity in Identity & Access - the foundation every later lab assumes.",
    "route": "/identity-core/idp-users",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d1-s6.etl"
    }
  },
  {
    "id": "training-d1-s8",
    "pluginId": "system-editor",
    "title": "Read-Only Peek: How a Connection Form Is Defined",
    "summary": "We will look, read-only, at how a connection form is generated from a system-type definition, so the fields we fill in on Days 2 and 4 make sense.",
    "route": "/system-editor",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d1-s8.etl"
    }
  },
  {
    "id": "training-d2-s1",
    "pluginId": "dc-connect",
    "title": "Tour the Data Collector App (dc-connect)",
    "summary": "We will tour dc-connect, the Data Collector application, learn its four tabs and KPI cards, and pick up the vocabulary (System, Inventory, stream) use",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s1.etl"
    }
  },
  {
    "id": "training-d2-s2",
    "pluginId": "dc-connect",
    "title": "Create the OpenLDAP DC System (New system)",
    "summary": "We will use the dc-connect New system wizard to create the OpenLDAP collector, walking all five steps (Source, Connect, Scope, Schedule, Review), test",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s2.etl"
    }
  },
  {
    "id": "training-d2-s3",
    "pluginId": "dc-connect",
    "title": "Create the Flat-File (synthetic_hr) DC System",
    "summary": "We will use the same New system wizard to create the synthetic_hr flat-file system, the Globex HR feed. Because flat file is file I/O, there is no cre",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s3.etl"
    }
  },
  {
    "id": "training-d2-s4",
    "pluginId": "dc-connect",
    "title": "Credentials and the OpenBAO Vault (Replace / Clear)",
    "summary": "We will understand how dc-connect handles secrets: written write-only to OpenBAO, never shown again, and rotated by Replace / Clear, a new secret behi",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s4.etl"
    }
  },
  {
    "id": "training-d2-s5",
    "pluginId": "dc-connect",
    "title": "Check System Health Before Collecting",
    "summary": "We will read system health in dc-connect, the status pills and the HealthBar, and run the Test connection health check (which collects no data) on bot",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s5.etl"
    }
  },
  {
    "id": "training-d2-s6",
    "pluginId": "dc-connect",
    "title": "Run the Inventory (Run now)",
    "summary": "We will use Run now to collect both systems to a terminal state, watching the live Collecting now state and the toasts up to Collection complete. The",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s6.etl"
    }
  },
  {
    "id": "training-d2-s7",
    "pluginId": "dc-connect",
    "title": "Read the Run in Activity and Runs",
    "summary": "We will read what a run did, using the global Activity feed and a system's Runs tab, then open a Run detail changeset (Added / Changed / Removed with",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s7.etl"
    }
  },
  {
    "id": "training-d2-s8",
    "pluginId": "dc-connect",
    "title": "Verify Collected Objects (Objects tab)",
    "summary": "We will verify collected data in the System-detail Objects tab, searching, filtering by All / Accounts / Groups, opening a read-only ObjectDetail, and",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s8.etl"
    }
  },
  {
    "id": "training-d2-s9",
    "pluginId": "dc-connect",
    "title": "Verify Groups and Membership",
    "summary": "We will confirm that inventory collected groups and their membership edges, not just accounts, using the ObjectDetail Members and Member of panels in",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s9.etl"
    }
  },
  {
    "id": "training-d2-s11",
    "pluginId": "identity-core",
    "title": "Verify Resolved Identities in Identity & Access",
    "summary": "We will confirm that identities resolved from the inventory appear in Identity & Access (/identity-core), proof the read path landed end to end.",
    "route": "/identity-core/idp-users",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s11.etl"
    }
  },
  {
    "id": "training-d2-s12",
    "pluginId": "dc-connect",
    "title": "Delta vs Full Reconciliation",
    "summary": "We will understand the two collection modes in dc-connect, Delta (a fetch optimization, state carried forward) and Full reconciliation (the always-on",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s12.etl"
    }
  },
  {
    "id": "training-d2-s13",
    "pluginId": "dc-connect",
    "title": "Troubleshoot a Failing Run with Activity",
    "summary": "We will trace a failing run end to end in dc-connect, from the system status note to the Activity feed to a Run detail changeset, then fix it with Tes",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d2-s13.etl"
    }
  },
  {
    "id": "training-d3-s1",
    "pluginId": "dc-connect",
    "title": "Create a Connector - Choose REST, Connect and Auth",
    "summary": "We will open dc-connect's 'Create a connector' wizard, meet its five steps (Choose -> Connect -> Entities -> Schedule -> Review), pick REST API as the",
    "route": "/dc-connect/profiles/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d3-s1.etl"
    }
  },
  {
    "id": "training-d3-s2",
    "pluginId": "dc-connect",
    "title": "Test the REST Connection (Real Probe)",
    "summary": "We will run the wizard's Test connection action - a real probe that fires a REST GET against the sandbox mock API - and read the success banner before",
    "route": "/dc-connect/profiles/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d3-s2.etl"
    }
  },
  {
    "id": "training-d3-s3",
    "pluginId": "dc-connect",
    "title": "Entities: Test Fetch, items_path, and Map Fields",
    "summary": "On the Entities step we will configure the Users object: enter its endpoint, run Test fetch for a live sample, let the wizard auto-detect the records",
    "route": "/dc-connect/profiles/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d3-s3.etl"
    }
  },
  {
    "id": "training-d3-s4",
    "pluginId": "dc-connect",
    "title": "Schedule, Review (compile), and Create the Type + System",
    "summary": "We will set the Schedule (full reconciliation plus optional incremental), review the compiled Universal YAML profile on the Review step (compile_profi",
    "route": "/dc-connect/profiles/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d3-s4.etl"
    }
  },
  {
    "id": "training-d3-s5",
    "pluginId": "dc-connect",
    "title": "Inventory the REST System and Verify",
    "summary": "We will Run now on the REST system we just built and confirm, in the Objects tab, that the sample population collected with the fields we mapped - com",
    "route": "/dc-connect",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d3-s5.etl"
    }
  },
  {
    "id": "training-d4-s1",
    "pluginId": "system-editor",
    "title": "Create the OpenLDAP CRUD connection (System Editor wizard)",
    "summary": "We will create the OpenLDAP write-path connection in the System Editor new-system wizard - the same directory we inventoried on Day 2, now built as it",
    "route": "/system-editor/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d4-s1.etl"
    }
  },
  {
    "id": "training-d4-s2",
    "pluginId": "system-editor",
    "title": "Test the CRUD connection (OpenLDAP)",
    "summary": "We will test the OpenLDAP CRUD connection from the Connection tab and confirm it is healthy before running any command.",
    "route": "/system-editor/openldap-crud",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d4-s2.etl"
    }
  },
  {
    "id": "training-d4-s3",
    "pluginId": "system-editor",
    "title": "Run a safe read command",
    "summary": "We will run a read command against OpenLDAP from the Test Commands tab - proving CRUD works without changing anything.",
    "route": "/system-editor/openldap-crud",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d4-s3.etl"
    }
  },
  {
    "id": "training-d4-s4",
    "pluginId": "system-editor",
    "title": "View and edit a user (safe write)",
    "summary": "We will make one safe, facilitator-approved attribute edit to a user - demonstrating the write path end to end.",
    "route": "/system-editor/openldap-crud",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d4-s4.etl"
    }
  },
  {
    "id": "training-d4-s5",
    "pluginId": "system-editor",
    "title": "Create the flat-file CRUD system (internal connector)",
    "summary": "We will create the flat-file CRUD system in the System Editor wizard and learn that flat file is an internal connector, so the wizard collects no conn",
    "route": "/system-editor/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d4-s5.etl"
    }
  },
  {
    "id": "training-d4-s6",
    "pluginId": "system-editor",
    "title": "Read the flat file on the write path",
    "summary": "We will run a read command against the flat-file CRUD system we created, mirroring Day 2's DC inventory - the same synthetic_hr data, now reachable th",
    "route": "/system-editor/synthetic-hr-crud",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d4-s6.etl"
    }
  },
  {
    "id": "training-d4-s7",
    "pluginId": "system-editor",
    "title": "Credentials: the create-new-secret model",
    "summary": "We will understand how credentials work on the write path: a system stores a pointer, and rotating a credential means writing a new secret behind the",
    "route": "/system-editor/openldap-crud",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d4-s7.etl"
    }
  },
  {
    "id": "training-d5-s1",
    "pluginId": "system-editor",
    "title": "Optional: create a standard connection - EntraID",
    "summary": "We will create an EntraID connection in the System Editor new-system wizard. EntraID is a standard, out-of-the-box connector, so we just pick the type",
    "route": "/system-editor/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d5-s1.etl"
    }
  },
  {
    "id": "training-d5-s2",
    "pluginId": "system-editor",
    "title": "Create a custom REST connector against Globex",
    "summary": "We will build a custom REST connector on the CRUD side in System Editor that targets the Globex HR app. Globex is not a shipped connector, so we build",
    "route": "/system-editor/new",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d5-s2.etl"
    }
  },
  {
    "id": "training-d5-s3",
    "pluginId": "system-editor",
    "title": "Test the Globex REST connection",
    "summary": "We will test the Globex REST connection we built, confirming auth and endpoint before running any command.",
    "route": "/system-editor/globex-hr-rest",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d5-s3.etl"
    }
  },
  {
    "id": "training-d5-s4",
    "pluginId": "system-editor",
    "title": "Read command + policy-masked PII (close the week)",
    "summary": "We will run a read command against Globex and observe policy-masked PII, then watch the live see-change loop where changing the policy or persona chan",
    "route": "/system-editor/globex-hr-rest",
    "source": {
      "kind": "etl",
      "path": "./tours/training/d5-s4.etl"
    }
  }
];
